export default function MjmlTitle() {
  return null;
}
